export const MAXSOUKOUKM = 999998;
export const MAXSOUKOUMILE = 621387;
